import React from "react";
import { Link } from "react-router-dom";
import LineChart from "../../charts/LineChart01";
import Icon from "../../images/icon-03.svg";
import EditMenu from "../../components/DropdownEditMenu";

// Import utilities
import { tailwindConfig, hexToRGB, formatValue } from "../../utils/Utils";
import Loader from "../../components/Loader.jsx";

function DashboardCard03({ labels, data, total, unit, loading, isIncomplete }) {
  const chartData = {
    labels,
    datasets: [
      // Indigo line
      {
        data,
        fill: true,
        backgroundColor: `rgba(${hexToRGB(
          tailwindConfig().theme.colors.blue[500]
        )}, 0.08)`,
        borderColor: tailwindConfig().theme.colors.indigo[500],
        borderWidth: 2,
        tension: 0,
        pointRadius: 3,
        pointHoverRadius: 5,
        pointBackgroundColor: tailwindConfig().theme.colors.indigo[500],
        pointHoverBackgroundColor: tailwindConfig().theme.colors.indigo[500],
        pointBorderWidth: 0,
        pointHoverBorderWidth: 0,
        clip: 20,
      },
    ],
  };

  return (
    <div className="flex flex-col col-span-full sm:col-span-6 xl:col-span-4 bg-white dark:bg-theme-surface-accent shadow-lg rounded-sm border border-slate-200 dark:border-slate-700">
      <div className="px-5 pt-5">
        <h2 className="text-lg font-semibold text-slate-800 dark:text-slate-100 mb-2">
          Average Order Value
        </h2>
        <div className="flex items-start">
          <div className="text-3xl font-bold text-slate-800 dark:text-slate-100 mr-2">
            {loading ? (
              <span className="absolute">
                <svg
                  className="animate-spin w-4 h-4 fill-current shrink-0"
                  viewBox="0 0 16 16"
                >
                  <path d="M8 16a7.928 7.928 0 01-3.428-.77l.857-1.807A6.006 6.006 0 0014 8c0-3.309-2.691-6-6-6a6.006 6.006 0 00-5.422 8.572l-1.806.859A7.929 7.929 0 010 8c0-4.411 3.589-8 8-8s8 3.589 8 8-3.589 8-8 8z" />
                </svg>
              </span>
            ) : (
              formatValue(total)
            )}
          </div>
        </div>
      </div>
      {/* Chart built with Chart.js 3 */}
      <div className="grow max-sm:max-h-[128px] xl:h-[256px]">
        {/* Change the height attribute to adjust the chart height */}
        {!loading && (
          <LineChart
            unit={unit}
            data={chartData}
            width={389}
            height={256}
            yFormatter={formatValue}
            isIncomplete={isIncomplete}
          />
        )}
        {loading && (
          <div className="flex items-center justify-center h-full">
            <div className="text-slate-800 dark:text-slate-100">Loading...</div>
          </div>
        )}
      </div>
    </div>
  );
}

export default DashboardCard03;
